<template>
    <tr :class="classes">
        <td :colspan="colspan" v-html="footer"></td>
    </tr>
</template>

<script>
    import Widget from './Widget';

    export default {
        extends: Widget,
        props: [
            'colspan',
            'footer'
        ],

        data() {
            return {
                classes:'table-footer'
            }
        }
    }
</script>
